document.addEventListener('DOMContentLoaded', () => {
  const moveBlog = document.querySelector('.moveBlog');
  const articleTemplateHeader = document.querySelector('.article-template header');
  const articleTemplateContent = document.querySelector('.article-template__content');

  if (articleTemplateHeader && moveBlog) {
    const headerClone = articleTemplateHeader.cloneNode(true);
    articleTemplateHeader.remove();
    moveBlog.appendChild(headerClone);
  }

  if (articleTemplateContent && moveBlog) {
    const contentClone = articleTemplateContent.cloneNode(true);
    articleTemplateContent.remove();
    moveBlog.appendChild(contentClone);
  }

  const submitButton = document.getElementById('submit-button');
  const selectElements = document.querySelectorAll('.variant-select');

  function checkSelects() {
    const allUnselected = Array.from(selectElements).every(select => select.value === "");
    if (allUnselected) {
      submitButton.disabled = true;
      submitButton.style.backgroundColor = 'rgb(150, 150, 150)';
    } else {
      submitButton.disabled = false;
      submitButton.style.backgroundColor = '';
    }
  }

  function resetSelects() {
    selectElements.forEach(select => {
      if (select.options.length > 0) {
        select.selectedIndex = 0;
      }
    });
    submitButton.disabled = true;
    submitButton.style.backgroundColor = 'rgb(150, 150, 150)';
  }

  const resetLink = document.getElementById('resetLink');
  if (resetLink) {
    resetLink.addEventListener('click', function(event) {
      event.preventDefault();
      resetSelects();
    });
  }

  selectElements.forEach(select => {
    select.addEventListener('change', checkSelects);
  });

  checkSelects();
});

window.addEventListener('pageshow', () => {
  const selectElements = document.querySelectorAll('.variant-select');
  const submitButton = document.getElementById('submit-button');
  if (!submitButton) return;

  selectElements.forEach(select => {
    if (select.options.length > 0) {
      select.selectedIndex = 0;
    }
  });
  submitButton.disabled = true;
  submitButton.style.backgroundColor = 'rgb(150, 150, 150)';
});